import { AttributesConfigurationDc, StyleDc } from "@evergis/api";
import { RangeValue } from "@evergis/ui";

import { StyleProxy } from "../classification/StyleProxy";
import { LayerInfo, TableInfo } from "../../../interfaces/resourceInfo";

export function createFailedServiceUpdate(layer: LayerInfo, table: TableInfo, defaultScaleRange: RangeValue) {
  const { name, configuration, alias, description } = layer || {};
  const attributesConfiguration = configuration && configuration.attributesConfiguration;

  const attributesToRemove = getRemovedAttributes(attributesConfiguration, table);
  const newAttributes = attributesConfiguration.attributes.filter(
    ({ attributeName }) => !attributesToRemove.includes(attributeName),
  );

  const style = removeClassificationsByAttributes(configuration.style, attributesToRemove, defaultScaleRange);

  return {
    ...configuration,
    name,
    alias,
    description,
    attributesConfiguration: {
      ...attributesConfiguration,
      attributes: newAttributes,
    },
    style,
  };
}

function getRemovedAttributes(attributesConfiguration: AttributesConfigurationDc, table: TableInfo) {
  const attributes = attributesConfiguration ? attributesConfiguration.attributes : [];
  const columns = (table && table.columns) || [];

  const attributeNames = attributes.map(({ attributeName }) => attributeName);
  const columnNames = columns.map(({ name }) => name);

  return attributeNames.filter(attributeName => columnNames.indexOf(attributeName) === -1);
}

function removeClassificationsByAttributes(
  style?: StyleDc,
  attributesToRemove?: string[],
  defaultScaleRange?: RangeValue,
) {
  if (style && attributesToRemove) {
    const styleProxy = new StyleProxy(style, defaultScaleRange);

    for (const attributeToRemove of attributesToRemove) {
      styleProxy.classificationManager.remove(({ attribute }) => attribute === attributeToRemove);
    }

    return styleProxy.serialize();
  }

  return style;
}
